import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  private _pdfApiUrl = `${environment.pdf}`;

  constructor(private _http: HttpClient) { }

  generatePdf(value: string, singlePage: boolean = false) {
    const params = new HttpParams().set('singlePage', singlePage.toString());
    return this._http.put(`${this._pdfApiUrl}/Generate`, value, {
      responseType: 'blob',
      params
    });
  }
  
}
